import { render } from "./training-invitation-details.vue?vue&type=template&id=7d99a560"
import script from "./training-invitation-details.vue?vue&type=script&lang=js"
export * from "./training-invitation-details.vue?vue&type=script&lang=js"
script.render = render

export default script